// eslint-disable-next-line no-unused-vars
var Project = Barba.BaseView.extend({
    namespace: 'project',
    onEnter: function() {
      $(window).off('scroll.hideprojectnav');
      $(window).on('scroll.hideprojectnav', function(event){
        var footerPosTop = $('.footer').get(0).getBoundingClientRect().top;
        var projNavBottom = $('.project__navnext').get(0).getBoundingClientRect().bottom;
        $('.project__navnext').toggleClass('hide', footerPosTop < projNavBottom );
      });       
    },
    onEnterCompleted: function() {
        
    },
    onLeave: function() {
      $(window).off('scroll.hideprojectnav');
    },
    onLeaveCompleted: function() {
    }
  });
